import { RemoteFileField } from '@utils/forms';
import * as t from 'io-ts';

export const remoteFile = t.type({
  url: t.string,
  name: t.string,
});

export type RemoteFile = t.TypeOf<typeof remoteFile>;

export const mapRemoteFieldToRemoteFileField = (c: RemoteFile): RemoteFileField => ({
  remote: c.url,
  file: new File([], c.name),
});

export const mapRemoteFileFieldToRemoteFile = (c: RemoteFileField): RemoteFile => ({
  url: c.remote ?? '',
  name: c.file?.name ?? 'File',
});
